var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { E_FILE_TYPE } from 'src/redux/core/types';
import { E_BASE_64_BY_EXTENSION } from 'src/redux/cases/helpers/filesParser';
var FileUrlsHelpers = /** @class */ (function () {
    function FileUrlsHelpers() {
    }
    FileUrlsHelpers.retrieveFileNotFetchingYet = function (fileUrls, newFileUrls) {
        if (!fileUrls) {
            return newFileUrls || null;
        }
        else if (!newFileUrls) {
            return fileUrls || null;
        }
        return Object.entries(newFileUrls)
            .filter(function (_a) {
            var fileUrl = _a[0];
            if (fileUrl.length < 1) {
                return false;
            }
            var fileUrlTargeted = fileUrls[fileUrl];
            // Not found in fileUrls state
            if (!!!fileUrlTargeted) {
                return true;
            }
            var file = fileUrlTargeted.file, isLoading = fileUrlTargeted.isLoading;
            // We don't want to add fileUrl which is already fetched or fetching
            // However if it's on error we want to try to re-fetch (if haven't file and isn't loading meaning is on error)
            return !(!!file || isLoading);
        })
            .reduce(function (acc, _a) {
            var _b;
            var fileUrl = _a[0], value = _a[1];
            return (__assign(__assign({}, acc), (_b = {}, _b[fileUrl] = value, _b)));
        }, {}); // return to object
    };
    FileUrlsHelpers.addFileUrls = function (fileUrls, newFileUrls, isAlreadyFiltered) {
        if (isAlreadyFiltered === void 0) { isAlreadyFiltered = false; }
        if (!fileUrls) {
            return newFileUrls || null;
        }
        else if (!newFileUrls) {
            return fileUrls || null;
        }
        var newFileUrlsFiltered = isAlreadyFiltered
            ? newFileUrls
            : FileUrlsHelpers.retrieveFileNotFetchingYet(fileUrls, newFileUrls);
        return __assign(__assign({}, fileUrls), newFileUrlsFiltered);
    };
    // Usefully to run callAPIs in sequence by batches of priority
    FileUrlsHelpers.splitFilesUrlsByPriority = function (filesUrls) {
        var fileUrlArray = Object.entries(filesUrls).map(function (_a) {
            var key = _a[0], value = _a[1];
            return __assign(__assign({}, value), { key: key });
        });
        var groupedByPriority = fileUrlArray.reduce(function (acc, fileUrl) {
            var _a;
            var priority = fileUrl.priority;
            // if no priority download last
            if (!priority) {
                return __assign(__assign({}, acc), { 0: __spreadArray(__spreadArray([], (acc[0] || []), true), [fileUrl], false) });
            }
            return __assign(__assign({}, acc), (_a = {}, _a[priority] = __spreadArray(__spreadArray([], (acc[priority] || []), true), [fileUrl], false), _a));
        }, {});
        // Reverse to start by the highest priority, cause object keys are sorted by ascending order
        var groupedByPriorityConvertInArray = Object.entries(groupedByPriority)
            .map(function (_a) {
            var key = _a[0], value = _a[1];
            return value;
        })
            .reverse();
        return groupedByPriorityConvertInArray;
    };
    FileUrlsHelpers.getFileType = function (payload) {
        if (!payload) {
            return E_FILE_TYPE.UNKNOWN;
        }
        var isMP4 = payload.startsWith(E_BASE_64_BY_EXTENSION.MP4);
        var isWebM = payload.startsWith(E_BASE_64_BY_EXTENSION.WEBM);
        var isJPEG = payload.startsWith(E_BASE_64_BY_EXTENSION.JPEG);
        var isPNG = payload.startsWith(E_BASE_64_BY_EXTENSION.PNG);
        var isPDF = payload.startsWith(E_BASE_64_BY_EXTENSION.PDF);
        var isTIF = payload.startsWith(E_BASE_64_BY_EXTENSION.TIF);
        var isTIFF = payload.startsWith(E_BASE_64_BY_EXTENSION.TIFF);
        if (isMP4 || isWebM) {
            return E_FILE_TYPE.VIDEO;
        }
        else if (isJPEG || isPNG || isTIF || isTIFF) {
            return E_FILE_TYPE.IMAGE;
        }
        else if (isPDF) {
            return E_FILE_TYPE.PDF;
        }
        else {
            return E_FILE_TYPE.UNKNOWN;
        }
    };
    FileUrlsHelpers.getMimeType = function (payload) {
        if (!payload || typeof payload !== 'string') {
            return null;
        }
        if (payload.startsWith(E_BASE_64_BY_EXTENSION.MP4)) {
            return 'video/mp4';
        }
        if (payload.startsWith(E_BASE_64_BY_EXTENSION.WEBM)) {
            return 'video/webm';
        }
        if (payload.startsWith(E_BASE_64_BY_EXTENSION.JPEG)) {
            return 'image/jpeg';
        }
        if (payload.startsWith(E_BASE_64_BY_EXTENSION.PNG)) {
            return 'image/png';
        }
        if (payload.startsWith(E_BASE_64_BY_EXTENSION.PDF)) {
            return 'application/pdf';
        }
        if (payload.startsWith(E_BASE_64_BY_EXTENSION.TIF) || payload.startsWith(E_BASE_64_BY_EXTENSION.TIFF)) {
            return 'image/tiff';
        }
        return null;
    };
    FileUrlsHelpers.getFileUrlType = function (apiPayload) {
        if (!apiPayload) {
            return E_FILE_TYPE.UNKNOWN; // default
        }
        var isArray = Array.isArray(apiPayload);
        if (isArray) {
            var firstItem = apiPayload[0];
            return FileUrlsHelpers.getFileType(firstItem);
        }
        var isBase64String = typeof apiPayload === 'string';
        if (isBase64String) {
            return FileUrlsHelpers.getFileType(apiPayload);
        }
        return E_FILE_TYPE.UNKNOWN;
    };
    FileUrlsHelpers.getFileUrlMimeType = function (apiPayload) {
        if (!apiPayload) {
            return null;
        }
        if (Array.isArray(apiPayload)) {
            return FileUrlsHelpers.getMimeType(apiPayload[0]);
        }
        if (typeof apiPayload === 'string') {
            return FileUrlsHelpers.getMimeType(apiPayload);
        }
        return null;
    };
    return FileUrlsHelpers;
}());
export { FileUrlsHelpers };
